import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .progress-container": {
    background: "#02002B",
    border: "#211F45 1px solid",
    borderRadius: "12px",
    padding: "16px",
    marginTop: "20px",
    "& .progress-item": {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
      "& .file-actions": {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        "& > span": {
          fontWeight: "300"
        },
        [theme.breakpoints.up("sm")]: {
          width: "40%",
        },
        [theme.breakpoints.down("md")]: {
          width: "100%",
        },
      },
    },
  },
}));
